import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load auth state from localStorage on mount
    const storedToken = localStorage.getItem('auth_token');
    const storedUsername = localStorage.getItem('username');
    const storedUserName = localStorage.getItem('user_name');

    if (storedToken) {
      setToken(storedToken);
      setUsername(storedUsername);
      setUserName(storedUserName);
    }
    setIsLoading(false);
  }, []);

  const login = (authToken, user, name) => {
    localStorage.setItem('auth_token', authToken);
    localStorage.setItem('username', user);
    localStorage.setItem('user_name', name);
    setToken(authToken);
    setUsername(user);
    setUserName(name);
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('username');
    localStorage.removeItem('user_name');
    setToken(null);
    setUsername(null);
    setUserName(null);
  };

  const getAuthHeaders = () => {
    if (!token) return {};
    return {
      Authorization: `Bearer ${token}`
    };
  };

  const value = {
    token,
    username,
    userName,
    isAuthenticated: !!token,
    isLoading,
    login,
    logout,
    getAuthHeaders
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

